import styled from "styled-components";
import { Button } from "antd";

export const GeographyResult = styled.div`
  border: 1px solid #ededed;
  width: 260px;
  position: absolute;
  top: 1rem;
  right: 1rem;
  background-color: #fff;
  border-radius: 3px;
`;

export const Header = styled.div`
  background-color: #000;
  color: #fff;
  padding: 1rem;
  border-radius: 3px;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  border-bottom: 1px solid #ededed;
`;

export const Info = styled.div`
  div {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 170px;
  }
`;

export const CloseButton = styled(Button)`
  margin-left: 1rem;
  background-color: rgb(245, 245, 246);
  color: rgb(236, 52, 53);
  transition: 0.2s ease all;
  &:hover {
    color: rgb(255, 255, 255);
    background-color: rgb(236, 52, 53);
    border-color: rgb(236, 52, 53);
  }
`;
